/**
 * Auth Store - Thin wrapper around inlined auth module
 *
 * Re-exports auth functionality with app-specific configuration.
 * All components continue to import from this file.
 */

import { createAuthStore } from "../auth/auth-store-factory";
import { getConfig } from "../config/runtime-config";

export type { User } from "../auth/types";

const { store, actions, hooks, utils } = createAuthStore({
  baseUrl: getConfig().authServiceUrl,
  authPathPrefix: getConfig().authPathPrefix,
});

export const authStore = store;
export const authActions = actions;
export const { useAuth, useAuthActions, useIsAuthenticated } = hooks;
export const { getUserLabel, getCurrentUserId } = utils;
